module.exports = __webpack_public_path__ + "static/01-48db449d27427e1eef6e4d5a7ec3b01a.jpg";